import { styled } from '@mui/material'

export const NotesContent = styled('div')({
  height: '100%', 
  display: 'flex', 
  flexDirection: 'column' 
});

export const NoteInfo = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%'
});

export const NoteText = styled('div')({
  paddingTop: '8px',
  fontSize: '14px',
});

export const Toolbar = styled('div')({
  padding: '20px',
  margin: 'auto 0 0 0',
  borderTop: 'solid 1px rgba(189, 195, 202, 1)',
});
